import Image from "next/image";
import Link from "next/link";
import { Phone, Mail } from "lucide-react";
import { useState } from 'react';
import axios from 'axios';


export default function Footer() {

  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [consentGiven, setConsentGiven] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [captchaKey, setCaptchaKey] = useState(0);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!consentGiven) {
      setMessage('A feliratkozáshoz el kell fogadnod az adatkezelésre vonatkozó tájékoztatónkat.');
      return;
    }
  
    if (!captchaToken) {
      setMessage('Kérjük, igazold, hogy nem vagy robot.');
      return;
    }
  
    try {
      await axios.post(`${process.env.NEXT_PUBLIC_STRAPI_URL}/api/newsletters/subscribe`, {
        data: { email, name, consentGiven, category: "Általános" },
      });
  
      setMessage('Sikeres feliratkozás!');
      setEmail('');
      setName('');
      setConsentGiven(false);
      setCaptchaToken(null);
      setCaptchaKey((prev) => prev + 1);
    } catch (error) {
      console.error(error);
      
      // Részletes hibakezelés a Strapi válasz alapján
      if (
        error.response &&
        error.response.data &&
        error.response.data.error &&
        typeof error.response.data.error.message === 'string'
      ) {
        setMessage(error.response.data.error.message);
      } else if (typeof error.response?.data?.message === 'string') {
        setMessage(error.response.data.message);
      } else {
        setMessage('Hiba történt a feliratkozás során.');
      }
    }
  };  

  return (
    <>
      {/* Háttérszín és szöveg szín */}
      <footer className="bg-black text-white py-10">
        <div className="container mx-auto px-4">
          {/* Rácsszerkezet a lábléc oszlopaihoz */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-8 items-stretch">
            {/* Első oszlop */}
            <div className="text-center">
              <div className="relative h-16 w-full max-w-[300px] mx-auto">
                <Image
                  src="/themes/kulturklub/logo/kulturklub_logo_2025_szoveg.webp"
                  alt="KulturKlub.Eu logó"
                  title="KulturKlub.Eu logó"
                  fill
                  className="object-contain"
                  loading="lazy"
                />
              </div>

              <p className="text-sm mt-4 text-justify">
                Ez az oldal azoknak szól, akik nem csupán eseményeket keresnek,
                hanem felejthetetlen élményeket. Az itt található programokat mi
                álmodjuk meg, mi valósítjuk meg – és mindig hozzáadunk egy
                csipetnyi különlegességet, hogy igazán maradandóvá tegyük őket.
                Csatlakozz a közösségünkhöz, és légy részese valami igazán
                páratlan élménynek!
              </p>
            </div>

            {/* Második és harmadik oszlop egy rácsban */}
            <div className="grid grid-cols-2 gap-4 xl:col-span-2">
              {/* Második oszlop */}
              <div className="text-center">
                <h2 className="text-lg font-bold mb-3">Kapcsolat</h2>

                    <p className="text-sm mb-1 text-center">
                      Általános kérdések:
                    </p>

                <p className="text-sm mb-2 flex items-center justify-center">
                  <Phone className="mr-2" size={16} />{" "}
                  <span>+36 30 567 7189</span>
                </p>


                <p className="text-sm mb-2 flex items-center justify-center">
                  <Mail className="mr-2" size={16} />
                  <a href="mailto:info@kulturklub.eu">
                    <span>info@kulturklub.eu</span>
                  </a>
                </p>

                    <p className="text-sm mb-1 text-center">
                      Sajtó/PR, művészeti szervező:<br/> Veszeli Annamária
                    </p>

                    <p className="text-sm mb-2 flex items-center justify-center">
                  <Phone className="mr-2" size={16} />{" "}
                  <span>+36 30 961 8574</span>
                    </p>

                <p className="text-sm mb-2 flex items-center justify-center">
                  <Mail className="mr-2" size={16} />
                  <a href="mailto:info@kulturklub.eu">
                    <span>sajto@kulturklub.eu</span>
                  </a>
                </p>



                <div className="flex justify-center mt-4">
                  <Image
                    src="/themes/kulturklub/logo/kulturklub_logo.png"
                    alt="KulturKlub.Eu logó"
                    title="KulturKlub.Eu logó"
                    width={160}
                    height={40}
                    className="object-contain mx-auto w-[130px] h-[100px] md:w-[200px] md:h-[50px] xl:w-[240px] xl:h-[120px]"
                    loading="lazy"
                  />
                </div>
              </div>

              {/* Harmadik oszlop */}
              <div className="text-center">
                <h2 className="text-lg font-bold mb-3">Fontos linkek</h2>
                <ul className="text-lg">
                  <li className="mb-4">
                    <Link href="/pages/aszf" className="text-sm">
                      ÁSZF
                    </Link>
                  </li>
                  <li className="mb-4">
                    <Link href="/pages/adatkezelesi-tajekoztato" className="text-sm">
                      Adatkezelés
                    </Link>
                  </li>
                </ul>
                <div className="flex flex-col items-center mt-4 space-y-4">
                  <Image
                    src="/themes/kulturklub/logo/simplepay_logo.png"
                    alt="SimplePay logó"
                    width={128}
                    height={64}
                    className="object-contain"
                  />
                  <Image
                    src="/themes/kulturklub/logo/stripe-logo-white-on-blue-gradient-1200x400.png"
                    alt="Stripe logó"
                    width={128}
                    height={64}
                    className="object-contain"
                  />
                </div>
              </div>
            </div>

            {/* Negyedik oszlop */}
            <div>
              <h2 className="text-lg font-bold mb-3">Csatlakozz hozzánk</h2>
              <p className="text-sm mb-4">
                Iratkozz fel hírlevelünkre, hogy ne maradj le semmiről! Nem
                küldünk felesleges információkat, csak azt, ami a lényeg.
              </p>
              <form onSubmit={handleSubmit} className="flex">
                <input
                  type="email"
                  placeholder="Email címed"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="p-2 flex-1 min-w-0 rounded-l bg-gray-800 text-white border border-gray-700"
                />
                <button
                  type="submit"
                  className={`p-2 bg-[#fe64db] text-white rounded-r animate-pulse ${captchaToken ? 'bg-blue-500 hover:bg-blue-600' : 'bg-gray-300 cursor-not-allowed'
                    } text-white rounded transition duration-200`}
                  disabled={!captchaToken}
                >
                  Feliratkozom
                </button>

                <div className="flex justify-center mb-4">

                </div>
              </form>
              <div className="mt-3">
                <input
                  type="checkbox"
                  id="consentGiven"
                  checked={consentGiven}
                  onChange={(e) => setConsentGiven(e.target.checked)}
                  className="mr-2"
                />
                <label htmlFor="consentGiven">
                  Elfogadom az <a href="/adatkezeles" target="_blank" className="underline">adatkezelési tájékoztatót</a>.
                </label>
              </div>
            </div>
          </div>

          {/* Alsó szöveg */}
          <div className="mt-10 border-t border-gray-700 pt-6 text-center">
            <p className="text-xs text-gray-400">
              © 2025 KulturKlub.Eu. Minden jog fenntartva.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}
